/* ============
 * SystemSettings Module
 * ============
 */

import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export default {
  state: {
    contractSettings: null,
    counterpartyGroup: null,
  },
  actions,
  mutations,
  getters,
};
